import "lightgallery.js";
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

import { app } from '../../utils/store';

gsap.registerPlugin(ScrollTrigger);

export default class Lamps{
    constructor(){
        this.header = document.querySelector('header');

        this.planimetry = document.querySelector('.planimetry');

        this.lamps = {
            container: document.querySelector('ul.lamps'),
            el: document.querySelector('.lamp'),
            lightbox: document.getElementById('lightbox'),
            toggler: document.querySelectorAll('.lamps .item'),
            viewer: document.querySelectorAll('.lg-item .description a'),
        };
    }

    init() {
        if(this.lamps.toggler){
            this.toggle();
            this.showreel();
        }
        this.animation();
    }

    toggle = () => {
        document.querySelector('body').classList.add('lg-lamps');

        lightGallery(this.lamps.lightbox, {
            mode: 'lg-fade',
            // startClass: 'lg-fade',
            subHtmlSelectorRelative: true,
            appendSubHtmlTo: '.lg-img-wrap',
            keypress: true,
            controls: true,
            download: false,
            counter: false,
            enableDrag: false,
            enableTouch: true,
            enableSwipe: false,
            hideControlOnEnd: true,
        });


        this.lamps.toggler.forEach((toggler) => {
            toggler.addEventListener('click', (e) => {
                var target = e.target.getAttribute('data-src');
                this.lamps.lightbox.querySelector('[data-src="' + target + '"').click();
            });
        });

        this.lamps.lightbox.addEventListener('onBeforeOpen', () => {
            this.header.classList.add('lg-active');
            document.querySelector('body').classList.add('overflow-hidden');
        });

        this.lamps.lightbox.addEventListener('onBeforeClose', () => {
            this.header.classList.remove('lg-active');
            document.querySelector('body').classList.remove('overflow-hidden');
        });
    }

    showreel = () => {
        this.lamps.viewer.forEach((viewer) => {
            viewer.addEventListener('mouseover', (e) => {
                // var target = e.target.getAttribute('src');
                this.lamps.viewer.parentElement.querySelector('.info .title').classList.add('hovering');
            });

            viewer.addEventListener('mouseleave', (e) => {
                // var target = e.target.getAttribute('src');
                this.lamps.viewer.parentElement.querySelector('.info .title').classList.remove('hovering');
            });
        });
    }

    animation = () => {
        // this.lamps.toggler.forEach((image) => {
            gsap.fromTo(this.lamps.toggler, 2,{
                y: 200,
                autoAlpha: 0,
            },{
                y: 0,
                autoAlpha: 1,
                stagger: .05,
                ease: 'expo.easeInOut',
                scrollTrigger: {
                    trigger: this.lamps.toggler,
                    start: '-=100% 60%',
                    end: 'center center',
                    toggleActions: "play none play reverse",
                },
            });

            // if(this.lamps.container.clientHeight > this.planimetry.clientHeight){
            //     gsap.to(this.planimetry, {
            //         scrollTrigger: {
            //             trigger: this.planimetry,
            //             start: 'top top+=50',
            //             pin: true,
            //         },
            //     })
            // }
        // });
    }
}
